import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getSuperAdminUserIsPosting,
    getSuperAdminUserPostSuccess,
    getSuperAdminUsersPostError,
} from '@selectors/superAdminUsers';
import { downgradeSuperAdminUser } from '@actions/superAdminUsers';

export default function useDowngradeSuperAdmin(userID: number): UseDowngradeSuperAdminReturn {
    const dispatch = useDispatch();

    const downgradeUser = useCallback(() => {
        dispatch(downgradeSuperAdminUser(userID, { roles: '{5}' }));
    }, [dispatch, userID]);

    const isPosting = useSelector(getSuperAdminUserIsPosting);
    const error = useSelector(getSuperAdminUsersPostError);
    const downgradeSuccess = useSelector(getSuperAdminUserPostSuccess);

    return {
        downgradeUser,
        isPosting,
        error,
        downgradeSuccess,
    };
}

interface UseDowngradeSuperAdminReturn {
    downgradeUser: () => void;
    isPosting: boolean;
    error: string | null;
    downgradeSuccess: boolean;
}
